import { Store, select } from '@ngrx/store';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';

//Interfaces
import { IAccidentDetail } from '@accidents/shared/interfaces/accidents';

// Store
import { ModuleState } from '@app/modules/accidents/store/reducers';
import * as DetailAccidentSelectors from '@accidents/store/selectors/detail-accident.selectors';

//Constants
import { ORIGEN_SINIESTRO } from '@accidents/shared/constants';
@Component({
    selector: 'sbi-cot-back-claim-data-tab',
    templateUrl: './claim-data-tab.component.html',
    styleUrls: ['./claim-data-tab.component.scss'],
    standalone: false
})
export class ClaimDataTabComponent implements OnInit {
  public claimDataForm: FormGroup;
  public accidentDetail: IAccidentDetail;

  // Servicio detalle siniestros
  private _accidentDetail$ = this._store$.pipe(
    select(DetailAccidentSelectors.selectDetailAccident)
  );

  constructor(
    private _formBuilder: FormBuilder,
    private _store$: Store<ModuleState>
  ) {}

  ngOnInit() {
    this._parseDatosAccidente();

    this._setDatosAccidenteForm();

    this._parseDatosForm();
  }

  // Private method to set the form data
  private _parseDatosAccidente(): void {
    this._accidentDetail$.subscribe((accidentRequest: IAccidentDetail) => {
      if (accidentRequest) {
        this.accidentDetail = accidentRequest;
      }
    });
  }

  // Private method for build the form
  private _setDatosAccidenteForm(): void {
    this.claimDataForm = this._formBuilder.group({
      tipoParte: [{ value: '', disabled: true }],
      numeroSiniestro: [{ value: '', disabled: true }],
      lugarAccidente: [{ value: '', disabled: true }],
      departamento: [{ value: '', disabled: true }],
      responsabilidadAsegurado: [{ value: '', disabled: true }],
      estadoTiempo: [{ value: '', disabled: true }],
      estadoSemaforo: [{ value: '', disabled: true }],
      estadoDeLaCalzada: [{ value: '', disabled: true }],
      cruceSenializado: [{ value: '', disabled: true }],
      denunciaPolicial: [{ value: '', disabled: true }],
      lesionados: [{ value: '', disabled: true }],
      espirometria: [{ value: '', disabled: true }],
      datosDenuncianteNombre: [{ value: '', disabled: true }],
      datosDenuncianteApellido: [{ value: '', disabled: true }],
      datosDenuncianteTelefono: [{ value: '', disabled: true }],
      datosDenuncianteTipoDocumento: [{ value: '', disabled: true }],
      datosDenuncianteDocumento: [{ value: '', disabled: true }],
      datosConductorSiniestroNombre: [{ value: '', disabled: true }],
      datosConductorSiniestroApellido: [{ value: '', disabled: true }],
      datosConductorSiniestroTelefono: [{ value: '', disabled: true }],
      datosConductorSiniestroTipoDocumento: [{ value: '', disabled: true }],
      datosConductorSiniestroDocumento: [{ value: '', disabled: true }],
    });
  }

  // Private method to set the form data
  private _parseDatosForm(): void {
    // Get form data
    const tipoParte = this.claimDataForm.get('tipoParte');
    const numeroSiniestro = this.claimDataForm.get('numeroSiniestro');
    const lugarAccidente = this.claimDataForm.get('lugarAccidente');
    const departamento = this.claimDataForm.get('departamento');
    const responsabilidadAsegurado = this.claimDataForm.get(
      'responsabilidadAsegurado'
    );
    const estadoTiempo = this.claimDataForm.get('estadoTiempo');
    const estadoSemaforo = this.claimDataForm.get('estadoSemaforo');
    const estadoDeLaCalzada = this.claimDataForm.get('estadoDeLaCalzada');
    const cruceSenializado = this.claimDataForm.get('cruceSenializado');
    const denunciaPolicial = this.claimDataForm.get('denunciaPolicial');
    const lesionados = this.claimDataForm.get('lesionados');
    const espirometria = this.claimDataForm.get('espirometria');
    const datosDenuncianteNombre = this.claimDataForm.get(
      'datosDenuncianteNombre'
    );
    const datosDenuncianteApellido = this.claimDataForm.get(
      'datosDenuncianteApellido'
    );
    const datosDenuncianteTelefono = this.claimDataForm.get(
      'datosDenuncianteTelefono'
    );
    const datosDenuncianteTipoDocumento = this.claimDataForm.get(
      'datosDenuncianteTipoDocumento'
    );
    const datosDenuncianteDocumento = this.claimDataForm.get(
      'datosDenuncianteDocumento'
    );
    const datosConductorSiniestroNombre = this.claimDataForm.get(
      'datosConductorSiniestroNombre'
    );
    const datosConductorSiniestroApellido = this.claimDataForm.get(
      'datosConductorSiniestroApellido'
    );
    const datosConductorSiniestroTelefono = this.claimDataForm.get(
      'datosConductorSiniestroTelefono'
    );
    const datosConductorSiniestroTipoDocumento = this.claimDataForm.get(
      'datosConductorSiniestroTipoDocumento'
    );
    const datosConductorSiniestroDocumento = this.claimDataForm.get(
      'datosConductorSiniestroDocumento'
    );

    // Rellenamos el Estado
    tipoParte.patchValue(this._getTipoParteValue());
    lesionados.patchValue('');
    numeroSiniestro.patchValue(this.accidentDetail.numeroSiniestroProveedor);
    if (this.accidentDetail.datosSiniestro) {
      lugarAccidente.patchValue(this.accidentDetail.datosSiniestro.ubicacion);
      departamento.patchValue(this.accidentDetail.datosSiniestro.localidad);
      responsabilidadAsegurado.patchValue(
        this.accidentDetail.datosSiniestro.responsabilidadDelAsegurado
      );
      estadoTiempo.patchValue(
        this.accidentDetail.datosSiniestro.estadoDelTiempo
      );
      estadoSemaforo.patchValue(
        this.accidentDetail.datosSiniestro.estadoDelSemaforo
      );
      estadoDeLaCalzada.patchValue(
        this.accidentDetail.datosSiniestro.estadoDeLaCalzada
      );
      cruceSenializado.patchValue(
        this.accidentDetail.datosSiniestro.cruceDeRutaSeñalizado
      );
      denunciaPolicial.patchValue(
        this.accidentDetail.datosSiniestro.denunciaPolicial
      );
    }
    if (
      this.accidentDetail.conductorMomentoSiniestro &&
      this.accidentDetail.conductorMomentoSiniestro.examenDeAlcoholemia
    ) {
      espirometria.patchValue(
        this.accidentDetail.conductorMomentoSiniestro.examenDeAlcoholemia.indexOf(
          '1-'
        ) == 0
      );
    }

    if (this.accidentDetail.datosDenunciante) {
      datosDenuncianteNombre.patchValue(
        this.accidentDetail.datosDenunciante.nombre
      );
      datosDenuncianteApellido.patchValue(
        this.accidentDetail.datosDenunciante.apellido
      );
      datosDenuncianteTelefono.patchValue(
        this.accidentDetail.datosDenunciante.telefonoDeContactoDelDenunciante
      );
      datosDenuncianteTipoDocumento.patchValue(
        this.accidentDetail.datosDenunciante.tipoDocumento
      );
      datosDenuncianteDocumento.patchValue(
        this.accidentDetail.datosDenunciante.nroDocumento
      );
    }

    if (this.accidentDetail.conductorMomentoSiniestro) {
      datosConductorSiniestroNombre.patchValue(
        this.accidentDetail.conductorMomentoSiniestro.nombre
      );
      datosConductorSiniestroApellido.patchValue(
        this.accidentDetail.conductorMomentoSiniestro.apellido
      );
      datosConductorSiniestroTelefono.patchValue(
        this.accidentDetail.conductorMomentoSiniestro.telefono
      );
      datosConductorSiniestroTipoDocumento.patchValue(
        this.accidentDetail.conductorMomentoSiniestro.tipoDocumento
      );
      datosConductorSiniestroDocumento.patchValue(
        this.accidentDetail.conductorMomentoSiniestro.nroDocumento
      );
    }
  }

  // Private method to get the Tipo Parte value
  private _getTipoParteValue(): string {
    let tipoValue = null;
    //ORIGEN_SINIESTRO
    switch (this.accidentDetail.proveedor) {
      case ORIGEN_SINIESTRO.AUXICAR.codigo:
        tipoValue = ORIGEN_SINIESTRO.AUXICAR.valor;
        break;
      case ORIGEN_SINIESTRO.HEYNOW.codigo:
        tipoValue = ORIGEN_SINIESTRO.HEYNOW.valor;
        break;
    }
    return tipoValue;
  }
}
